import {
  ApiOrdersPlaceOrdersRequestedAction,
  apiOrdersPlaceOrdersFailed,
  apiOrdersPlaceOrdersSucceeded
} from '@spa/lib/store/api/orders/placeOrdersApi';
import { call, put, select } from 'typed-redux-saga';
import placeOrdersAction, {
  PlaceOrdersActionInput,
  PlaceOrdersActionResult
} from '@spa/lib/actions/orders/placeOrdersAction';
import { OptionalStateCarts } from '@spa/lib/store/carts/CartsState';
import { SkuWithQuantity } from '@spa/lib/graphql/buildSkusQueryParamValue';
import { cartQuantityValidationFailed } from '@spa/lib/store/carts/cartsSlice';
import selectCarts from '@spa/lib/store/carts/selectors/selectCarts';

const collectOrderedProducts = (
  carts: OptionalStateCarts,
  cartIds: ReadonlyArray<string>
): ReadonlyArray<SkuWithQuantity> => {
  const orderedProducts: Array<SkuWithQuantity> = [];

  Object.values(carts).forEach((cart) => {
    if (cart !== null && cartIds.includes(cart.code)) {
      cart.entries.forEach((entry) => {
        orderedProducts.push({ code: entry.product.code, quantity: entry.quantity });
      });
    }
  });

  return orderedProducts;
};

function* placeOrdersSaga({
  payload: {
    casCartId,
    homeCartId,
    actionId: requestedActionId,
    parentActionId,
    additionalData,
    emarsysParams
  }
}: ApiOrdersPlaceOrdersRequestedAction): Generator {
  try {
    const carts = yield* select(selectCarts);
    const orderedProducts = collectOrderedProducts(
      carts,
      [casCartId, homeCartId].filter((cartId): cartId is string => cartId !== null)
    );
    const input: PlaceOrdersActionInput = {
      casCartId,
      homeCartId,
      additionalData,
      emarsysParams,
      orderedProducts
    };
    const { casResult, homeResult }: PlaceOrdersActionResult = yield* call(
      placeOrdersAction,
      'placeOrdersAction',
      input
    );

    for (const [cartId, orderResult] of [
      [casCartId, casResult],
      [homeCartId, homeResult]
    ] as const) {
      if (cartId !== null && orderResult?.validationErrors?.length) {
        yield* put(cartQuantityValidationFailed({ cartId, errors: orderResult.validationErrors }));
      }
    }

    yield* put(
      apiOrdersPlaceOrdersSucceeded({
        requestedActionId,
        parentActionId,
        casCartId,
        homeCartId,
        casResult,
        homeResult
      })
    );
  } catch (e) {
    yield* put(
      apiOrdersPlaceOrdersFailed({
        error: e?.toString() ?? '',
        requestedActionId,
        parentActionId
      })
    );
  }
}

export default placeOrdersSaga;
